import React from "react";
import Drawer from "@mui/material/Drawer";
// import Hidden from "@mui/material/Hidden";
import { Theme } from "@mui/material/styles";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
import clsx from "clsx";
// import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
// import { selectMobileDrawer, toggleMobileDrawerAction } from "src/app-redux/settings/settingsSlice";
import { DrawerContent } from "./DrawerContent";

export const DRAWER_WIDTH = 227;
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      width: DRAWER_WIDTH,
      flexShrink: 0,
      whiteSpace: "nowrap",
    },
    drawerOpen: {
      width: DRAWER_WIDTH,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: theme.spacing(2) + 1,
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(6) + 7,
      },
    },
  })
);

type Props = { open: boolean; toggleDrawer: () => void };

export function SideNav(props: Props) {
  const classes = useStyles();
  // const dispatch = useAppDispatch();

  // If using material-ui theme mediaQuery
  // const theme = useTheme();
  // const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  // const mobileOpen = useAppSelector(selectMobileDrawer);

  return (
    <Drawer
      variant="permanent"
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: props.open,
        [classes.drawerClose]: !props.open,
      })}
      classes={{
        paper: clsx({
          [classes.drawerOpen]: props.open,
          [classes.drawerClose]: !props.open,
        }),
      }}
    >
      <DrawerContent />
    </Drawer>
  );
}
